import type { FunctionComponent } from 'react';
import type * as T from './ButtonWithAuth.types';
import Button from '@media-ui/core/src/components/Button';
import { pushToWeborama } from 'Src/tools/weborama';
import { snitchCounter } from 'Tools/counters/snitchCounter';
import { applyAuth } from '@media-platform/tool-auth';
import { counterTrigger } from 'Src/tools/counters';
const ButtonWithAuth: FunctionComponent<T.IButtonWithAuthProps> = (props) => {
    const { href, children, buttonProps, weboramaOpts, snitchCounter: snitchCounterName, clickCounter, onClick, } = props;
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        applyAuth().then(() => {
            if (onClick) {
                onClick(e);
            }
            if (weboramaOpts) {
                pushToWeborama(weboramaOpts.type, weboramaOpts.value);
            }
            if (snitchCounterName) {
                snitchCounter(snitchCounterName);
            }
            if (clickCounter) {
                counterTrigger(clickCounter);
            }
            if (href) {
                window.location.href = href;
            }
        });
    };
    return (<Button.Link {...buttonProps} href={href} onClick={handleClick}>
      {children}
    </Button.Link>);
};
export default ButtonWithAuth;
